import React from 'react'
import { InputNumber } from "primereact/inputnumber";

import InputWrapper from './InputWrapper';

// Utilities

import { setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function NumberInput(props) {
    const {
        formik,
        fieldName,
        isRequired,
        placeholder,
        min,
        max,
        maxLength,
        disabled
    } = props;

    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    return (
        <InputWrapper {...props}>

            <InputNumber 
                id={fieldName}
                name={fieldName}
                value={fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName]}
                onChange={(e) => formik.setFieldValue(fieldName, e.value)}
                onBlur={formik.handleBlur(fieldName)}
                placeholder={placeholder}
                className={`input-field ${error && touched ? 'p-invalid' : ''}`}
                required={isRequired}
                min={min}
                max={max}
                maxLength={maxLength}
                disabled={disabled}
            />

        </InputWrapper>
    )
}

